// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Iwx7","right":"styles_right__1JGGX"};